import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_38() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter November 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            UK Implements Regulatory Framework for ESG Ratings Providers Under
            FCA.
          </title>
          <meta
            name="description"
            content="The United Kingdom has introduced a regulatory framework to bring Environmental, Social, and Governance (ESG) ratings providers under the supervision of the Financial Conduct Authority (FCA), effective June 2028."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          UK Implements Regulatory Framework for ESG Ratings Providers Under
          FCA.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Nov_2025_1.webp")}
            alt="UK Implements Regulatory Framework for ESG Ratings Providers Under FCA."
            loading="lazy"
          />
        </figure>
        <p>
          The United Kingdom has introduced a regulatory framework to bring
          Environmental, Social, and Governance (ESG) ratings providers under
          the supervision of the Financial Conduct Authority (FCA), effective
          June 2028. This framework requires all ESG ratings providers offering
          services to UK clients, whether domestic or international, to obtain
          FCA authorisation. The initiative is rooted in the objective of
          enhancing transparency, governance, controls, and consistency in ESG
          ratings methodologies and data handling. The FCA will release detailed
          regulatory guidance following a consultation process scheduled for
          late 2025.
        </p>
        <p>
          This oversight includes establishing standards related to internal
          governance, systems and controls, conflict of interest management, and
          disclosure of methodologies and data sources. Ratings providers will
          need to demonstrate robust processes to ensure the accuracy and
          reliability of their ESG assessments. The new regime also provides
          specific exemptions, such as for certain overseas ESG ratings and
          regulated MiFID ancillary services, designed to balance regulatory
          coverage with operational practicality. These measures align with
          global regulatory trends, including the European Union's ESG
          oversight, which begins implementation in July 2026, and reflect
          recommendations from international bodies emphasising the need for
          dependable ESG data frameworks.
        </p>
        <p>
          Historically, the lack of a unified regulatory approach has been noted
          in various reports. For example, a 2023 global survey highlighted that
          ESG ratings and data providers varied widely in methodologies, with
          many investors expressing the need for greater transparency and
          standardised criteria to enhance comparability. In response, the UK’s
          regulatory move builds on these findings, aiming to formalise the
          sector by instituting clear standards and fostering investor
          confidence in ESG evaluations. The FCA’s initiative follows increasing
          market demand for consistent and verifiable ESG information as
          sustainable finance continues to expand internationally.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Rating Agencies should develop clear documentation of methodologies,
            rigorous risk management processes, and systems ensuring
            independence between commercial interests and rating outcomes. Early
            engagement in the FCA consultation process and aligning operational
            practices with IOSCO recommendations will position providers to
            maintain market access and demonstrate regulatory compliance in a
            maturing ESG ratings environment.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          South Korea Implements Sustainable Aviation Fuel Blending Mandate for
          International Flights.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Nov_2025_2.webp")}
              alt="South Korea Implements Sustainable Aviation Fuel Blending Mandate for International Flights."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          South Korea has announced a mandatory sustainable aviation fuel (SAF)
          blending requirement for all international flights departing its
          airports beginning in 2027. The initial mandate sets a 1% SAF blend,
          which will progressively increase to 3–5% by 2030 and reach between 7%
          and 10% by 2035. This roadmap, jointly developed by the Ministry of
          Land, Infrastructure and Transport and the Ministry of Trade, Industry
          and Energy, represents a strategic move to reduce aviation-related
          greenhouse gas emissions and foster cleaner air transport fuel use in
          the country.
        </p>
        <p>
          From 2028, international airlines are required to source at least 90%
          of their annual refueling volumes at South Korean airports with SAF
          blends. The mandate offers flexibility, allowing carriers to defer up
          to 20% of their annual SAF requirement for fulfillment within three
          years and provides a phased approach to compliance for new market
          entrants. Fuel producers and suppliers will face penalties for falling
          short of SAF supply obligations, calculated at 1.5 times the price
          difference between SAF and conventional jet fuel, encouraging stronger
          market participation.
        </p>
        <p>
          Sustainable aviation fuel primarily originates from renewable
          feedstocks such as waste oils, agricultural residues, and municipal
          solid waste, with potential greenhouse gas reductions of up to 80%
          compared to fossil jet fuel. South Korea's position as a leading
          global jet fuel exporter supports expected strong domestic SAF demand,
          near 556,000 barrels by 2027. The government’s initiatives include
          collaboration with industry stakeholders and incentives like tax
          credits, aiming to build a robust local SAF production and supply
          ecosystem while aligning with international climate objectives and
          aviation sector decarbonization efforts.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The policy addresses key issues such as reducing fossil fuel
            dependence, expanding sustainable feedstock availability, and
            developing SAF infrastructure. It supports the diversification of
            supply chains and encourages domestic production growth through a
            phased implementation approach. This fosters adaptation within fuel
            supply logistics, market regulations, and airline operational
            practices, driving progress towards lower emissions. The initiative
            reshapes industry standards and prepares the aviation sector for
            meeting emerging environmental regulations globally.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Singapore Introduces New Guidance to Enhance Accuracy and Transparency
          in Environmental Claims.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Nov_2025_3.webp")}
            alt="Singapore Introduces New Guidance to Enhance Accuracy and Transparency in Environmental Claims."
            loading="lazy"
          />
        </figure>
        <p>
          Singapore’s Competition and Consumer Commission (CCS) has issued a
          detailed set of guidelines aimed at supporting businesses in making
          environmental and product-related claims that are accurate and
          verifiable. This initiative addresses concerns about vague or
          misleading claims that have been prevalent, particularly in online
          marketing. A 2022 study by CCS revealed that over 50% of online claims
          were unclear or insufficiently supported, often using technical or
          ambiguous language that made it difficult for consumers to assess
          their validity.
        </p>
        <p>
          The guidelines emphasize five principles: claims must be true and
          accurate, clear and easily understood, meaningful by focusing on
          material product attributes, accompanied by sufficient and accessible
          information, and supported by credible, up-to-date evidence.
        </p>
        <p>
          The guidance is designed to help businesses comply with existing fair
          trading laws while fostering transparency and trust among consumers.
          It provides practical advice with case studies developed through
          consultations with industry and business associations. The CCS
          highlights that claims such as "eco-friendly" or "sustainable" need
          careful substantiation to avoid exaggeration relative to actual
          environmental benefits. Notable past cases in Singapore include a 2023
          advertisement promoting energy-efficient air conditioners with
          unsubstantiated environmental impacts and a 2024 travel promotion
          making environmental claims without qualifiers. The new framework aims
          to strengthen the quality of environmental marketing and ensure
          businesses’ sustainability claims are grounded in fact.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            This development is part of a broader regional and global trend to
            regulate environmental marketing more rigorously, especially as ESG
            language evolves and businesses intensify efforts to demonstrate
            genuine sustainability. While greenwashing cases have decreased
            globally over recent years, regulators recognize the importance of
            setting clear expectations for businesses. The Singaporean approach
            aligns with increasing international regulatory attention and seeks
            to foster informed consumer choices through enhanced corporate
            accountability and transparent communication.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Morocco Announces 2040 Timeline to End Coal Power and Strengthen
          Renewables Development.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Nov_2025_4.webp")}
            alt="Morocco Announces 2040 Timeline to End Coal Power and Strengthen Renewables Development."
            loading="lazy"
          />
        </figure>
        <p>
          Morocco has established a target to phase out coal-fired power
          generation by 2040, conditional on the availability of international
          climate finance to facilitate this transition. Currently, coal
          accounts for approximately 70% of the country's electricity supply.
          The government aims to increase the share of renewable energy to
          around 52% by 2030, focusing on expanding solar and wind capacity
          alongside modernizing the power infrastructure. Achieving the coal
          phase-out depends significantly on securing external funding that
          ensures the availability of affordable clean energy alternatives and
          supports a just transition for workers and communities impacted by the
          shift away from coal.
        </p>
        <p>
          The national energy transition strategy builds on Morocco's ongoing
          renewable energy development, including projects like the Noor
          Ouarzazate solar complex—one of the largest concentrated solar power
          facilities globally—and multiple wind farms along the Atlantic coast.
          These initiatives contribute to reducing reliance on fossil fuels and
          position Morocco as a potential green electricity exporter to Europe
          through future grid interconnections. The planned shift is aligned
          with Morocco’s commitments under the Paris Agreement and its
          Sustainable Development Goals, particularly those focusing on
          affordable clean energy, decent work, and climate action.
        </p>
        <p>
          Despite these plans, the implementation timeline is subject to the
          availability of climate finance from multilateral institutions and
          private investors. Without access to concessional funding and
          technology transfer, the 2040 coal phase-out goal could be revised.
          This plan reflects a broader need for international cooperation that
          balances environmental objectives with economic and social
          considerations in energy transitions for developing economies. It also
          highlights Morocco's approach toward integrating sustainable
          development and climate policies within its energy framework.​
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Morocco's leadership in renewable energy development, evidenced by
            projects like the Noor Ouarzazate solar complex and Atlantic wind
            farms, positions it as a potential clean energy exporter in the
            region. This move aligns with global trends where renewables are
            overtaking coal, reflecting a worldwide decline in coal capacity
            expansion and accelerating clean energy adoption. The country's move
            underscores the critical role of coordinated international finance
            and cooperation in enabling developing economies to achieve just and
            effective energy transitions.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          ISSB Proposes Global Framework for Cross-Border Use of Sustainability
          Reporting Standards.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Nov_2025_5.webp")}
            alt="ISSB Proposes Global Framework for Cross-Border Use of Sustainability Reporting Standards."
            loading="lazy"
          />
        </figure>

        <p>
          The International Sustainability Standards Board (ISSB), under the
          IFRS Foundation, has launched a structured initiative to support the
          use of its sustainability disclosure standards across jurisdictions.
          The objective is to allow companies that prepare reports in line with
          ISSB standards to use them as a globally accepted framework for
          sustainability reporting. To support this, the ISSB has expanded its
          Jurisdictional Adopters Working Group and introduced a new
          Jurisdictional Rationale Guide and accompanying tools. These are
          intended to help regulatory authorities incorporate ISSB standards
          into their domestic regimes while accommodating jurisdiction-specific
          requirements where necessary.
        </p>
        <p>
          The initiative addresses growing momentum in regulatory developments
          worldwide. According to the IFRS Foundation, around 40 jurisdictions
          are currently in the process of evaluating or implementing ISSB
          standards. The passporting approach is designed to minimize
          duplicative reporting obligations for companies operating across
          borders. It offers a pathway for companies to have a single
          sustainability report recognized in multiple markets, provided there
          is alignment with ISSB’s global baseline. This supports more efficient
          capital allocation, greater consistency in disclosures, and better
          access to comparable information for investors. The ISSB’s standards
          are built on established frameworks such as the TCFD and SASB, which
          many jurisdictions and market participants are already familiar with.
        </p>
        <p>
          In the year following the release of IFRS S1 and S2, adoption interest
          has continued to grow. These standards focus on general
          sustainability-related disclosures and climate-specific risks and
          opportunities. The ISSB’s work also aligns with the broader objectives
          of the Financial Stability Board and IOSCO, which have endorsed the
          standards as foundational for capital market transparency. In addition
          to government regulators, stock exchanges, institutional investors,
          and accounting bodies are participating in efforts to integrate ISSB
          standards within financial reporting systems. The current phase
          involves building the infrastructure necessary to operationalize
          equivalence and interoperability across borders, a process that will
          require collaboration between public and private sectors.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The introduction of a global passporting mechanism for ISSB
            standards may gradually recalibrate capital flows by reducing
            informational asymmetries in sustainability performance. As
            jurisdictions align reporting requirements, markets can more
            efficiently price climate and ESG-related risks. This could lower
            the cost of capital for transparent firms, encourage long-term
            investment, and create conditions where sustainability becomes
            embedded not as a compliance function but as a systemic feature of
            financial decision-making.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_38;
